import { useUser } from "@libs:react-query-auth";
import { startCase } from "lodash";
import { Navigate, Outlet } from "react-router";
import { useDocumentTitle } from "usehooks-ts";

import { Routes } from "@:constants";

export const ProtectedRoute = () => {
  const user = useUser();

  useDocumentTitle(startCase("Nemo AI"));

  return user.data ? <Outlet /> : <Navigate to={Routes.Login} replace />;
};
